/** A single-line control. Never render one without a `Field` around it. */

import type { InputHTMLAttributes, Ref } from "react";

import { cn } from "@/lib/cn";

import "../internal/control.css";
import "./Input.css";

export interface InputProps extends InputHTMLAttributes<HTMLInputElement> {
  /** Tabular monospace, for a code, an id or an address. */
  readonly mono?: boolean;
  readonly invalid?: boolean;
  readonly ref?: Ref<HTMLInputElement>;
}

export function Input({ mono, invalid, className, ...rest }: InputProps) {
  return (
    <input
      aria-invalid={invalid === true ? true : undefined}
      className={cn(
        "al-control",
        "al-input",
        mono === true ? "al-mono" : undefined,
        invalid === true ? "al-control-invalid" : undefined,
        className,
      )}
      {...rest}
    />
  );
}
